var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"drag",staticClass:"zy-main-drag",style:({'visibility': (_vm.left === 1 || _vm.left === 0) ? 'hidden' : ''}),on:{"mousedown":_vm.handleMousedown}})}
var staticRenderFns = []

export { render, staticRenderFns }